import store from '../../store/store'
import { refresherAxiosInstance } from '../api/refresh_client'

const refreshAuthLogic = async failedRequest => {
  if (failedRequest.request.responseURL.includes('/logout')) {
    return Promise.reject(new Error('Error'))
  }
  let refreshToken = store.getters.refreshToken
  let data = new window.FormData()
  data.append('auth[refresh_token]', refreshToken)
  let headers = { headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  }}
  await refresherAxiosInstance.post('/refresh', data, headers)
    .then(res => {
      let token = res.data.token.token
      if (token) {
        store.dispatch('updateToken', {token: token})
        failedRequest.response.config.headers['Authorization'] = 'Bearer ' + token
        return Promise.resolve()
      } else {
        return Promise.reject(new Error('Error'))
      }
    })
}

export default refreshAuthLogic



// WEBPACK FOOTER //
// ./src/services/auth/refresh.js